import axiosInstance from './AxiosInstance'; // Reuse the centralized Axios instance

const ServiceLevelService = {
  fetchServiceLevel: async (page, pageSize, sortBy, order,searchTerm) => {
    const queryObj = { 
      page, 
      pageSize,
      sortBy,
      order,
      searchTerm: searchTerm?.trim() || "", 
    };
    try {
      const response = await axiosInstance.get('/serviceLevel', {
        params: queryObj, // Query parameters
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching ServiceLevels:', error);
      throw error;
    }
  },

  createServiceLevel: async (data) => {
    try {
      const response = await axiosInstance.post('/serviceLevel', data);
      console.log("response.data------------", response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating ServiceLevel:', error);
      throw error;
    }
  },

  updateServiceLevel: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/serviceLevel/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating ServiceLevel with ID ${id}:`, error);
      throw error;
    }
  },

  deleteServiceLevel: async (id) => {
    try {
      const response = await axiosInstance.delete(`/serviceLevel/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting ServiceLevel with ID ${id}:`, error);
      throw error;
    }
  },
};

export default ServiceLevelService;
